import { getConfig } from './config'

export type Ticket = {
  locale: 'pt-br'
  subject: string
  body: string
}

export const create = async (ticket: Ticket): Promise<void> => {
  const config = getConfig()
  await config.axios.post(`${config.API_URL}/helpers/contact`, ticket)
}
